<div class="ft-form">
    <div class="ft-form-row">
        <div class="history-list position-relative border rounded-lg p-3 w-100 d-flex flex-column">

            <!-- Loading -->
            @if (chatThreadsResource.isLoading()) {
                <div class="loading-icon position-absolute w-100 h-100"></div>
            } @else {
                <!-- Thread list -->
                @if (hasChatThreads()) {
                    @for (thread of chatThreadsResource.value(); track thread.thread_id) {
                        <div class="item history-thread d-flex justify-content-between align-items-center border rounded-lg p-2 w-100 mb-2"
                             [class.active]="activeThreadId() === thread.thread_id"
                             (click)="selectThread(thread)"
                             (keydown.enter)="selectThread(thread)"
                             tabindex="0">

                            <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                            
                                @if (thread.preview_asset_url) {
                                <img [src]="thread.preview_asset_url" class="history-thumbnail mr-3 rounded" alt="Chat Preview" loading="lazy" />
                                } @else {
                                <div
                                    class="history-thumbnail-placeholder mr-3 rounded d-flex justify-content-center align-items-center bg-light text-muted">
                                    <i class="fa fa-comment-dots"></i>
                                </div>
                                }

                            <div class="d-flex flex-column pr-3 overflow-hidden">
                                <span class="text-truncate">{{ thread.name || 'Untitled chat' }}</span>
                                <span class="text-muted small">{{ thread.modified_at | relativeTime }}</span>
                            </div>
                            </div>

                            <button class="report-card__delete" type="button"
                                    (click)="deleteThread(thread.thread_id, $event)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    }
                } @else {
                    <!-- Empty state -->
                    <div class="text-muted small p-3 text-center w-100 flex-grow-1 d-flex flex-column justify-content-center">
                        {{ "aiReport.lbl_no_chats_yet" | translate }}
                    </div>
                }
            }

        </div>
    </div>
    <div class="footer">
        <button class="ft-btn ft-btn-active-not-selected" (click)="cancel()">{{"lbl_cancel" | translate}}</button>
    </div>
</div>
